import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DeletePathologyRes;
export const DeletePathologyTodo = createAsyncThunk('DeletePathology', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Delete",
            url: process.env.REACT_APP_API_URL + `superadmin/company_master/${id}`,
          
            headers: { "Content-Type": "application/json" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return DeletePathologyRes = res.data
        
    } catch (error) {
        return DeletePathologyRes = error.response.data
    }
})
